export const CATALOG_BOOKSET_DETAIL_SET_DATA = 'CATALOG_BOOKSET_DETAIL_SET_DATA';
export const CATALOG_BOOKSET_DETAIL_RESET_DATA = 'CATALOG_BOOKSET_DETAIL_RESET_DATA';
export const CATALOG_BOOKSET_LIST_SET_DATA = 'CATALOG_BOOKSET_LIST_SET_DATA';

export const CATALOG_BOOKSHELF_DETAIL_SET_DATA = 'CATALOG_BOOKSHELF_DETAIL_SET_DATA';
export const CATALOG_BOOKSHELF_DETAIL_RESET_DATA = 'CATALOG_BOOKSHELF_DETAIL_RESET_DATA';

export const CATALOG_SERIES_DETAIL_SET_DATA = 'CATALOG_SERIES_DETAIL_SET_DATA';
export const CATALOG_SERIES_DETAIL_RESET_DATA = 'CATALOG_SERIES_DETAIL_RESET_DATA';

export const CATALOG_AUTHOR_DETAIL_SET_DATA = 'CATALOG_AUTHOR_DETAIL_SET_DATA';
export const CATALOG_AUTHOR_DETAIL_RESET_DATA = 'CATALOG_AUTHOR_DETAIL_RESET_DATA';

export const CATALOG_AUTHOR_BOOK_LIST_SET_DATA = 'CATALOG_AUTHOR_BOOK_LIST_SET_DATA';
export const CATALOG_AUTHOR_BOOK_LIST_RESET_DATA = 'CATALOG_AUTHOR_BOOK_LIST_RESET_DATA';

export const CATALOG_AUTHOR_LIST_SET_DATA = 'CATALOG_AUTHOR_LIST_SET_DATA';
export const CATALOG_AUTHOR_LIST_RESET_DATA = 'CATALOG_AUTHOR_LIST_RESET_DATA';

export const CATALOG_NICHE_DETAIL_SET_DATA = 'CATALOG_NICHE_DETAIL_SET_DATA';
export const CATALOG_NICHE_DETAIL_RESET_DATA = 'CATALOG_NICHE_DETAIL_RESET_DATA';

export const CATALOG_GENRE_DETAIL_SET_DATA = 'CATALOG_GENRE_DETAIL_SET_DATA';
export const CATALOG_GENRE_DETAIL_RESET_DATA = 'CATALOG_GENRE_DETAIL_RESET_DATA';

export const CATALOG_BOOK_LIST_SET_DATA = 'CATALOG_BOOK_LIST_SET_DATA';
export const CATALOG_BOOK_LIST_RESET_DATA = 'CATALOG_BOOK_LIST_RESET_DATA';

export const CATALOG_CATALOG_INDEX_SET_DATA = 'CATALOG_CATALOG_INDEX_SET_DATA';
export const CATALOG_CATALOG_FREE_INDEX_SET_DATA = 'CATALOG_CATALOG_FREE_INDEX_SET_DATA';

export const CATALOG_TAG_DETAIL_SET_DATA = 'CATALOG_TAG_DETAIL_SET_DATA';
export const CATALOG_TAG_DETAIL_RESET_DATA = 'CATALOG_TAG_DETAIL_RESET_DATA';
export const CATALOG_TAG_LIST_SET_DATA = 'CATALOG_TAG_LIST_SET_DATA';

export const CATALOG_NICHE_BOOK_LIST_SET_DATA = 'CATALOG_NICHE_BOOK_LIST_SET_DATA';
export const CATALOG_NICHE_BOOK_LIST_RESET_DATA = 'CATALOG_NICHE_BOOK_LIST_RESET_DATA';

export const CATALOG_AUTHOR_REVIEWS_SET_DATA = 'CATALOG_AUTHOR_REVIEWS_SET_DATA';
export const CATALOG_AUTHOR_REVIEWS_RESET_DATA = 'CATALOG_AUTHOR_REVIEWS_RESET_DATA';

export const CATALOG_AUTHOR_CITATIONS_SET_DATA = 'CATALOG_AUTHOR_CITATIONS_SET_DATA';
export const CATALOG_AUTHOR_CITATIONS_RESET_DATA = 'CATALOG_AUTHOR_CITATIONS_RESET_DATA';

export const CATALOG_ACTOR_AUDIOBOOKS_SET_DATA = 'CATALOG_ACTOR_AUDIOBOOKS_SET_DATA';
export const CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA = 'CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA';

export const CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA = 'CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA';
export const CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA = 'CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA';

export const POPULAR_NICHES_ID_LIST = [2, 22, 1, 4, 24, 3, 2895];

export const AUTHOR_SUBSCRIBE_MESSAGES = {
  SUBSCRIBE_SUCCESS: '👍 Автор добавлен в Избранное. Как только у нас появятся новые книги, мы отправим вам письмо',
  UNSUBSCRIBE_SUCCESS: '✂️ Автор удален из Избранного. Мы не будем присылать вам письма о его новинках',
  ERROR: 'Произошла ошибка',
};

export function GET_SEO_META(type, audioBooksCounter) {
  const seoDict = {
    byDefault: {
      title: 'Библиотека — MyBook.',
      description: 'Каталог лучших книг и новинок литературы. Рейтинги книг и рецензии читателей. '+
                  'Искусство, детективы, любовные романы, детские книги, психология, фэнтези, '+
                  'фантастика, дом, семья, приключения. Возможность удобно читать книги онлайн по подписке.',
    },
    free: {
      title: 'Читать книги онлайн бесплатно в электронной библиотеке MyBook.',
      description: 'Каталог лучших книг и новинок литературы. Рейтинги книг и рецензии читателей. '+
                  'Искусство, детективы, любовные романы, детские книги, психология, фэнтези, '+
                  'фантастика, дом, семья, приключения. Возможность удобно читать книги онлайн по подписке.',
    },
    popular: {
      title: 'Популярные книги (по мнению читателей нашей библиотеки) разных жанров в электронной библиотеке MyBook.',
      description: 'Каталог популярных книг разных жанров по мнению наших читателей. '+
                  'Искусство, детективы, любовные романы, детские книги, психология, фэнтези, '+
                  'фантастика, дом, семья, приключения. Возможность удобно читать книги онлайн по подписке.',
    },
    'new-book': {
      title: 'Новые книги: актуальный список свежих книг разных жанров в электронной библиотеке MyBook.',
      description: 'Новые книги в электронной библиотеке MyBook. Актуальный список новинок в мире литературы. '+
                  'Новинки книг разных жанров. Искусство, детективы, любовные романы, детские книги, психология, '+
                  'фэнтези, фантастика, дом, семья, приключения. Читайте каждый день новые книги в нашей библиотеке.',
    },
    rating: {
      title: 'Рейтинг книг (по мнению читателей нашей библиотеки) разных жанров в электронной библиотеке MyBook.',
      description: 'Рейтинг лучших книг и новинок литературы в разных жанрах. '+
                  'Искусство, детективы, любовные романы, детские книги, психология, фэнтези, '+
                  'фантастика, дом, семья, приключения. Возможность удобно читать книги онлайн по подписке.',
    },
    audio: {
      title: 'Аудиокниги онлайн – слушайте лучшие книги онлайн на MyBook',
      description: 'Лучшие аудиокниги, новинки, любимые авторы и лучшие подборки в электронной библиотеке MyBook.' +
                    `В онлайн библиотеке MyBook доступно ${audioBooksCounter} аудиокниг.` +
                    `Регистрируйтесь и слушайте более ${audioBooksCounter} аудиокниг.`,
    },
  };
  return seoDict[type || 'byDefault'];
};
